/*
    This service dynamically load the microfrontend applications to widow object
*/
import { shouldLoadMFE } from '../utils/mfeJobCodeValidation';

const noopLifecycle = {
  bootstrap: () => Promise.resolve(),
  mount: () => Promise.resolve(),
  unmount: () => Promise.resolve()
};

export const microfrontendApplicationsLoadService = async (
  ApplicationName,
  userProfileData = null
) => {
  try {
    const actualMfeName = ApplicationName.replace(/-route$/, '');

    if (userProfileData) {
      const mfeConfig = await window['@MFEConfig'];
      const mfeEntry = mfeConfig?.MFES?.[actualMfeName];
      if (
        mfeEntry &&
        !shouldLoadMFE(mfeEntry, userProfileData.userApplicationRole, userProfileData.jobProfileId)
      ) {
        console.log('MFE blocked from loading:', actualMfeName);
        return noopLifecycle;
      }
    }

    return await window[actualMfeName]();
  } catch (error) {
    console.log('Error occured while loading application: ', error);
    return noopLifecycle;
  }
};
